{
  "lastUpdatedAt": "2026-06-09T13:43:34.568Z",
  "lastFetchAttemptAt": "2026-06-09T13:43:34.568Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}